export const version = '5.0.0'
export const supportLink = 'https://www.cellcrypt.com/about'
export const companyName = 'CSG Inc'
export const platformName = 'Cellcrypt'
export const mode: 'public' | 'private' = 'public'
export const storeURL = 'https://www.cellcrypt.com/store'
export const flavor = 'ccnew'
export const CAPTCHA_KEY = '6LdfK90qAAAAAOuAIQgLRYWwpECx98Ibg_OLyhnT'
